var React = require('react');

function RedArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.28692 0.294861C5.8954 0.686664 5.8954 1.31835 6.28692 1.71015L8.57215 3.99701L0.998789 3.99701C0.447457 3.99701 -2.42826e-07 4.44478 -2.1871e-07 4.99651C-1.94593e-07 5.54823 0.447457 5.99601 0.998789 5.99601L8.57215 5.99601L6.28692 8.29086C5.91138 8.66667 5.91138 9.32234 6.28692 9.70615C6.67845 10.098 7.30969 10.098 7.70121 9.70615L11.6964 5.70815L11.7683 5.62019C11.8162 5.56422 11.8722 5.48426 11.9201 5.38031C11.968 5.26037 12 5.12444 12 4.99651L11.992 4.90855C11.984 4.8046 11.96 4.70865 11.9201 4.6127C11.8722 4.48476 11.7923 4.38081 11.7044 4.28486L7.7092 0.286865C7.30968 -0.0969432 6.67046 -0.0969432 6.28692 0.294861Z","fill":"#FF547D"}));
}

RedArrow.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = RedArrow;

RedArrow.default = RedArrow;
